// "⇄ Likely transfer?" -- sits in the feed at its date (#s05). Confirm
// calls POST /api/transactions/links (`useConfirmLink`). "Not a transfer"
// has no M1 backend (`.../reject` is 501) -- it renders disabled with the
// honest reason rather than a silent no-op (execution plan §9.8).
import { AmountText } from '@/components/AmountText';
import { Button } from '@moneyskyline/ui';
import type { LinkCandidate } from '@/api/hooks/useLinkCandidates';

export function TransferReviewCard({
  candidate,
  onConfirm,
  confirming = false,
  error,
}: {
  candidate: LinkCandidate;
  onConfirm: (candidateId: string) => void;
  confirming?: boolean;
  error?: string;
}) {
  const [legA, legB] = candidate.legs;
  return (
    <div
      className="border-l-4 border-money-neutral bg-card p-3"
      data-testid="transfer-review-card"
      data-candidate-id={candidate.candidate_id}
    >
      <div className="text-sm font-semibold text-money-neutral">⇄ Likely transfer?</div>
      <div className="mt-1 text-xs text-foreground-secondary">
        {legA.account.display_name} •{legA.account.last4} <AmountText value={legA.amount} currency={legA.currency} className="text-xs" />{' '}
        {new Date(legA.posted_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })} ↔{' '}
        {legB.account.display_name} •{legB.account.last4} <AmountText value={legB.amount} currency={legB.currency} className="text-xs" />{' '}
        {new Date(legB.posted_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
      </div>
      <div className="mt-2.5 flex min-h-11 gap-2">
        <Button
          type="button"
          size="sm"
          className="min-h-11"
          onClick={() => onConfirm(candidate.candidate_id)}
          disabled={confirming}
        >
          Confirm
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="min-h-11"
          disabled
          aria-disabled="true"
        >
          Not a transfer
        </Button>
      </div>
      {error && (
        <p role="alert" className="mt-2 text-sm text-destructive">
          {error}
        </p>
      )}
      <p className="mt-1 text-xs text-muted-foreground">
        Not a transfer is not available yet. Until you confirm, both transactions continue to count as ordinary activity.
      </p>
    </div>
  );
}

export default TransferReviewCard;
